export const GET_BRANDING_DATA = "GET_BRANDING_DATA";
export const CLEAR_BRANDING_DATA = "CLEAR_BRANDING_DATA";